<!-- The glyph. `aria-hidden`, because it repeats the tone the role already carries and names nothing a screen
     reader can read; explicitly sized (`h-5 w-5`), because an <svg> carrying only a viewBox collapses to 0×0
     in WebKit (Bug #218); `flex-none`, so a long sentence wraps against the text column and never squeezes the
     icon into an ellipse. -->
<svg aria-hidden="true" class="h-5 w-5 flex-none" fill="currentColor" viewBox="0 0 16 16"
     xmlns="http://www.w3.org/2000/svg">
  <path [attr.d]="iconPath()"/>
</svg>
<!-- `min-w-0` so the sentence may wrap inside the flex row rather than forcing the box wider than its column;
     with `items-center` on the host, a wrapped block stays optically centred against the icon. -->
<span class="min-w-0"><ng-content/></span>
